import IconCell from "../../../../../../core-ui/IconCell/IconCell";
import {Box} from "@mui/material";

export const getColumns = tableColumns =>
    tableColumns.map((column, index) => ({
        title: column,
        field: index,
        align: 'left',
        width: (index==3) ? '50px' : '100px',
        disableSorting: true,
        render: row => (index==3) ?
            (
                <Box>
                    <IconCell value={row[3] ? 'activ' : 'inactiv'} />
                </Box>
            )
            : row[index]
    }))

export const getRows = (
  depositNameList,
  paxdDepositNameList,
  hubNameList,
  acceptReturnsList
) => {

  let rows = []

  depositNameList.map((element, index) => {
      const row = [element, paxdDepositNameList[index], hubNameList[index], acceptReturnsList[index]]
      rows.push(row)
      })

  return rows
}
